import React,{useState} from 'react'
import { Link } from 'react-router-dom';
// Danish Work Start
import { auth,authz } from "../Services/firebase";
import {createUserWithEmailAndPassword} from "firebase/auth"
import toast, { Toaster } from 'react-hot-toast';
// Danish import ends
import { signup, signInWithGoogle } from "../Utils/FirebaseAuth";
import { FormGroup, FormControl, Form, Button } from "react-bootstrap";
const FirebaseSignupFunctional=()=> {
  const[getuserAndBusinessData,setgetuserAndBusinessData] = useState({
    userEmail:'',
    userName:'',
    userPassword:'',
    userPhoneNumber:0,
    type:'individual',
    businessName:'',
    businessLicenceId:''
  });
  const getType=(e)=>{
    setgetuserAndBusinessData({...getuserAndBusinessData,type:e.target.value})
  }
  const getUerName =(e)=>{
    setgetuserAndBusinessData({...getuserAndBusinessData,userName:e.target.value})
  }
  const getUserEmail =(e)=>{
    setgetuserAndBusinessData({...getuserAndBusinessData,userEmail:e.target.value})
  }
  const getUserPhoneNumber =(e)=>{
    setgetuserAndBusinessData({...getuserAndBusinessData,userPhoneNumber:e.target.value})
  }
  const getUserPassword =(e)=>{
    setgetuserAndBusinessData({...getuserAndBusinessData,userPassword:e.target.value})
  }
  const getbusinessName =(e)=>{
    setgetuserAndBusinessData({...getuserAndBusinessData,businessName:e.target.value})
  }
  const getLicenseId =(e)=>{
    setgetuserAndBusinessData({...getuserAndBusinessData,businessLicenceId:e.target.value})
  }
  // const sendDataTofireBase =async()=>{
  //   try {
  //     await signup(getuserAndBusinessData.userEmail,getuserAndBusinessData.userPassword,getuserAndBusinessData.userName);
  //     console.log('User After Signup is ',getuserAndBusinessData);
  //   } catch (error) {
  //     console.log('Errors is registering the user :',error.message);
  //   }
  // }
  const sendDataTofireBase =async()=>{
    try {
     const data = await signup(getuserAndBusinessData.userEmail,getuserAndBusinessData.userPassword,getuserAndBusinessData.userName);
     
     const response = await data;
     console.log('User After Signup is ',response);
    } catch (error) {
      toast.error(error.message);
      console.log('Errors is registering the user :',error.length);
    }
  }
  return (
    <div className='d-flex align-items-center mb-5'>
    <div className='flex-1 container'>
      <div className="signInDiv margin-top-100">
        <p className='bold-font h4  themeColor2 text-center'>Sign Up</p>
        <p className='para light-font '></p>

        <div className='googleButton'>
          <img width="30px" src='/Images/google-logo.ico' className='mr-3' />
          Sign up with Google
        </div>
        <div className='googleButton mt-2' >
          <img width="30px" src='/Images/facebook.png' className='mr-3' />
          Sign up with Facebook
        </div>
        <div className='position-relative my-5' >
          <div className='app-border mx-auto'></div>
          <span className='login-opt light-font para'>or Sign up with Email</span>
        </div>

        <form className=''>

        <div className="form-group">
        <span className='bold-semifont para'>Type*</span>
          <select className="form-control" placeholder="Business Type" name="type" onChange={getType} value={getuserAndBusinessData.type} aria-label="Default select example">
            <option selected>Select Type</option>
            <option value="business">Business</option>
            <option value="individual">Individual</option>
          </select>
        </div>
        {
          getuserAndBusinessData.type === "business"?
          <>
          <div className="form-group">
           <span className='bold-semifont para'>Business Name*</span>
             <input className="form-control" type="text" placeholder="Business Name" name="businessName" onChange={getbusinessName} value={getuserAndBusinessData.businessName} ></input>
           </div>
           <div className="form-group">
           <span className='bold-semifont para'>License Id*</span>
             <input className="form-control" type="text" placeholder="License Id" name="licenseId" onChange={getLicenseId} value={getuserAndBusinessData.businessLicenceId} ></input>
           </div>
          </>:null
        // this.state.type == "business" ?
        // <>
        //   <div className="form-group">
        //   <span className='bold-semifont para'>Business Name*</span>
        //     <input className="form-control" type="text" placeholder="Business Name" name="businessName" onChange={this.handleChange} value={this.state.businessName} ></input>
        //   </div>
        //   <div className="form-group">
        //   <span className='bold-semifont para'>License Id*</span>
        //     <input className="form-control" type="text" placeholder="License Id" name="licenseId" onChange={this.handleChange} value={this.state.licenseId} ></input>
        //   </div>
        // </>
        // :
        //""
        }
        <div className="form-group">
        <span className='bold-semifont para'>Name*</span>
          <input className="form-control" type="text" placeholder="User name" name="userName" onChange={getUerName} value={getuserAndBusinessData.userName} ></input>
        </div>

        <div className="form-group">
          <span className='bold-semifont para'>Email*</span>
          <input className="form-control" placeholder="Email" name="email" type="email" onChange={getUserEmail} value={getuserAndBusinessData.userEmail}></input>
        </div>
        <div className="form-group">
          <span className='bold-semifont para'>Phone No.*</span>
          <input className="form-control" placeholder="Phone Number" name="phoneNumber" type="text" onChange={getUserPhoneNumber} value={getuserAndBusinessData.userPhoneNumber}></input>
        </div>
        <div className="form-group">
          <span className='bold-semifont para'>Password*</span>
          <input className="form-control" placeholder="Password" name="password" onChange={getUserPassword} value={getuserAndBusinessData.userPassword} type="password"></input>
        </div>

        <div className="form-group text-center">
          {
          // this.state.error ? 
          //   <p className="text-danger">{this.state.error}</p>
          //  : null
           }
          <Button className='round-button' onClick={sendDataTofireBase}>Sign up</Button>
        </div>
        <div className='app-border'></div>
        <p className='light-font'>
        Already have an account? <Link to="/login" style={{color:"#28b8dc"}}>Sign In</Link>
        </p>
      </form>
      </div>
    </div>
    <Toaster></Toaster>
  </div>
  )
}

export default FirebaseSignupFunctional